import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet, Router } from '@angular/router';
import { ModalService } from '../../services/modal.service';

import { I18nTranslator } from '../../i18n/translate';
import { Farm } from '../../models/farm.model';
import { Country } from '../../models/lists.model';
import { User } from '../../models/user.model';
import { FarmService } from '../../services/farm.service';
import { KeycloakService } from '../../services/keycloak.service';
import { ListsService } from '../../services/lists.service';
import { UserService } from '../../services/user.service';
import { PreventDoubleClickDirective } from '../../utils/preventDoubleClick';
import { showErrorMessage } from '../../utils/utils';
import { TranslatePipe, TranslateWithPunctuationPipe } from '../../pipes/translate.pipe';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'farm-edit',
  templateUrl: 'farm-edit.component.html',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, PreventDoubleClickDirective, TranslatePipe, TranslateWithPunctuationPipe, CommonModule, FormsModule],
  providers: [FarmService, UserService],
})
export class FarmEditComponent implements OnInit, OnDestroy {
  @Input() farm: Farm;
  @Output() close = new EventEmitter();
  error: any;
  sub: any;
  edited = false; // true if navigated here
  countries: Country[];
  farmId: number;
  alreadyLoad = false;

  isPartner = false;
  isAdmin: boolean;

  users: User[];

  constructor(
    private farmService: FarmService,
    private listService: ListsService,
    private userService: UserService,
    private i18nTranslator: I18nTranslator,
    private modal: ModalService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.isAdmin = KeycloakService.auth.authz.hasRealmRole('ROLE_ADMIN');
  }

  goBack(savedFarm: Farm = null) {
    this.close.emit(savedFarm);
    this.router.navigate(['/farms']);
    return false;
  }

  getCountries() {
    this.listService.getCountries().subscribe((countries) => (this.countries = countries));
  }

  getFarmers() {
    this.userService.getUsers(null, ['ROLE_FARMER', 'ROLE_ADVISOR', 'ROLE_MANAGER']).subscribe((users) => {
      this.users = users;
      if (this.users && this.users.length === 1) {
        this.farm.user = this.users[0];
      }
    });
  }

  save() {
    this.farmService.save(this.farm).subscribe(
      (farm) => {
        this.farm = farm;
        this.goBack(farm);
      },
      (error) => {
        this.handleSaveError(error);
      },
    );
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe((params) => {
      if (this.route.snapshot.url[1].path === 'edit') {
        this.farmId = +params['farmId'];
        this.edited = true;
        // FIXME traiter les erreurs
        this.farmService.getFarm(this.farmId).subscribe(
          (farm) => {
            this.farm = farm;
            if (!this.farm.country || !this.farm.country.id) {
              this.farm.country = new Country();
              this.farm.country.id = 1;
            }
            if (!this.farm.user || !this.farm.user.id) {
              this.farm.user = new User();
              this.farm.user.id = null;
            }
            if (this.farm.identifiantFms) {
              if (this.farm.identifiantFms.startsWith('WIUZ:') || this.farm.identifiantFms.startsWith('SMAG:')) {
                this.isPartner = true;
              }
            }
            this.users = [this.farm.user];
          },
          (error) => this.handleGetError(error),
        );
      } else if (this.route.snapshot.url[1].path === 'new') {
        this.edited = false;
        this.farm = new Farm();
        this.farm.country = new Country();
        // France par défaut
        this.farm.country.id = 1;
        this.farm.user = new User();
        this.farm.user.id = null;

        if (this.farm.identifiantFms) {
          if (this.farm.identifiantFms.startsWith('WIUZ:') || this.farm.identifiantFms.startsWith('SMAG:')) {
            this.isPartner = true;
          }
        }
        this.users = [this.farm.user];
      }
    });

    this.getCountries();
  }

  handleSaveError(error: any) {
    if (error.status === 401) {
      showErrorMessage(this.modal, this.i18nTranslator.translate('farm.edit.unauthorized'));
    } else {
      // FIXME détailler les erreurs du formulaire
      // FIXME définir un format pour les erreurs de validation
      console.error(error);
      showErrorMessage(this.modal, this.i18nTranslator.translate('edit.error.generic'));
    }
  }

  handleGetError(error: any) {
    if (error.status === 401) {
      showErrorMessage(this.modal, this.i18nTranslator.translate('farm.edit.view.unauthorized')).then((r) => {
        this.router.navigate(['/farms']);
      });
    } else {
      console.error(error);
      showErrorMessage(this.modal, this.i18nTranslator.translate('error.generic')).then((r) => {
        this.router.navigate(['/farms']);
      });
    }
  }

  loadFarmer() {
    if (!this.alreadyLoad) {
      this.alreadyLoad = true;
      this.getFarmers();
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
